export default {
  Index: "system-error",
};
